import {Injectable} from '@angular/core';
import {Backend, SingleResponse} from '@generated-backend-types';
import Patient = Backend.App.Resources.Dashboard.Patient;
import {ApiService} from '../api.service';
import {Observable, take} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class AssignPatientToMeService extends ApiService {
  public assignPatientToMe(patientId: string): Observable<Patient> {
    return this.http.post<SingleResponse<Patient>>(`/patients/${patientId}/assign-to-me`, {})
      .pipe(take(1), map(value => value.data))
  }
}
